// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1U4zN","ranges":"BmiRanges_ranges__1cwJK"};